<template>
  <div
    :class="{
      'header--container': true,
      'is-open': isOpen,
      'is-closed': !isOpen,
    }"
  >
    <div v-if="activeLayout === 'osr-facing' || activeLayout === 'client-facing'" style="max-width: 100vw; overflow: hidden">
      <div v-if="activeLayout === 'osr-facing'">
        <div id="institution-switcher" v-if="activeLayout === 'osr-facing'" class="osr-facing">
          <span id="switch-institutions">Switch institutions: </span>
          <Dropdown v-if="options.length > 0 && activeInstitution" @selected="(option) => setActiveInstitutionId(option.id)" @filter="() => null" :options="options" :maxItem="1000" :defaultItem="activeInstitution" />
        </div>
      </div>
      <div id="header-area" class="osr client has-background-white osr-header-area">
        <div class="left-side">
          <img class="bank-logo" :src="logo" />

          <b class="bank-name" :title="getInstitutionsName()">{{ getInstitutionsName() }}</b>
        </div>

        <div class="right-side" style="padding: 0 !important" :class="{ 'grid-2x2': reportTypeCodes.includes('CCC'), 'grid-1x3': !reportTypeCodes.includes('CCC') }">
          <button v-if="reportTypeCodes.includes('CCC')" @click="handleStandardConfirmationClick" type="button " class="is-small button has-text-white is-rounded has-bcc-hover-background has-text-weight-semibold">
            <spin-loader v-if="acquiringStandardConfirmationInstructions" style="margin-right: 8px" />
            <i v-else class="fa fa-file-text-o" style="margin-right: 8px" />

            Get Standard Confirmation Instructions
          </button>

          <button @click="handleCalculateFinancialImpactButtonClick" type="button " class="is-small button has-text-white is-rounded has-bcc-hover-background has-text-weight-semibold">
            <i class="fa fa-calculator" style="margin-right: 8px"></i>
            Calculate Financial Impact of New BOLI
          </button>

          <button @click="router.push({ name: 'BankUploads' })" type="button " class="is-small button has-text-white is-rounded has-bcc-hover-background has-text-weight-semibold">
            <i class="fa fa-upload" style="margin-right: 8px"></i>
            Client Uploads
          </button>

          <button @click="router.push({ name: 'ServiceRequest' })" type="button " class="is-small button has-text-white is-rounded has-bcc-hover-background has-text-weight-semibold">
            <i class="fa fa-user" style="margin-right: 8px"></i>
            Service Request
          </button>
        </div>
      </div>
    </div>

    <div v-if="activeLayout === 'administrative'">
      <div id="header-area" class="has-background-white">
        <div id="header-left" class="flex">
          <h2 style="font-size: 1.2rem; font-weight: 600">Welcome, {{ user.firstName }} {{ user.lastName }}</h2>
        </div>

        <div id="header-center" style="text-align: center">
          <!-- <div v-if="sites && sites.length > 0" id="institution-switcher" class="admin-facing">
            <div id="switch-institutions">Active Site:</div>
            <Dropdown v-if="sites.length > 0 && activeSite.id" @selected="(option) => setActiveSiteId(option.id)" @filter="() => null" :options="sites" :maxItem="1000" :defaultItem="{ id: activeSite.id, name: activeSite.name }" />
          </div> -->
        </div>

        <div id="header-right">
          <div id="header-logo" class="flex">
            <img :src="activeSite.logoUrl" style="max-height: 70px" />
          </div>
        </div>
      </div>
    </div>

    <sidebar-menu v-if="!isFullScreen && (activeLayout === 'osr-facing' || activeLayout === 'client-facing')" :activeLayout="activeLayout" :activeSite="activeSite" :activeUser="user" @openChanged="($event) => (isOpen = $event)" />
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { store } from '../legacyStore'
import Dropdown from './partials/dropdowns/SearchableDropdown.vue'
import SidebarMenu from './SidebarMenu.vue'
import axios from '../axios'
import { authFlow } from '@/lib/auth'
import { bus } from '../main'
import { useGlobalUtils } from '../helpers/globalUtils'
import { useRouter } from 'vue-router'
import useApi from '../composables/useApi'
import Constants from '../constants'
import moment from 'moment-timezone'

const { auditActionsEventTypes } = Constants
const { handleApiErr, successToast, warningToast } = useGlobalUtils()

const props = defineProps({
  activeLayout: {
    type: String,
    required: true,
  },
})

const router = useRouter()
const api = useApi()

// const carrierAuditOngoing = ref(false)
const institutions = ref([])
const activeInstitution = ref(null)
const isFullScreen = ref(false)
const options = ref([])
const sites = ref([])
const user = reactive({ id: 0, firstName: '', lastName: '', institution: { name: '', logo: '' } })
const logo = ref(null)
const isOpen = ref(true)
const acquiringStandardConfirmationInstructions = ref(false)
const isLoading = ref(false)

const clientSession = store.state.clientSession
const activeSite = store.state.activeSite

const activeInstitutionId = computed({
  get: () => clientSession.institutionId,
  set: async (value) => {
    await setActiveInstitutionId(value)
    getOptions()
  },
})

const handleCalculateFinancialImpactButtonClick = async () => {
  await api.logAuditAction({
    actionType: auditActionsEventTypes.CLICK,
    action: api.customAuditActions.click_calculateFinancialImpactButton,
    actionDescription: 'Clicked Calculate Financial Impact of New BOLI Button in Header',
    clientId: clientSession.institutionId,
    timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSS'),
  })

  router.push({ name: 'FinancialImpact' })
}

function sortByInArray(arr, key) {
  return arr.slice().sort((a, b) => (a[key] > b[key] ? 1 : -1))
}

const reportTypeCodes = ref([])
const getMembershipData = async () => {
  const req = await api.getMembershipsData(clientSession.userId)
  reportTypeCodes.value = req['reportTypeCodes']
}

// const getInstitutionCarrierAuditStatus = async () => {
//   const req = await axios.get(`/CarrierAudit/institution-audit-status/${clientSession.institutionId}`)
//   if (req.status >= 200 && req.status < 300) {
//     carrierAuditOngoing.value = req.data
//   } else {
//     console.error('Error fetching carrier audit status')
//   }
// }

const handleStandardConfirmationClick = async () => {
  acquiringStandardConfirmationInstructions.value = true
  const req = await axios.get(`/CarrierAudit/request-audit-data/${clientSession.institutionId}`)

  if (req.status >= 200 && req.status < 300) {
    successToast('Generating and sending an email to you with instructions for obtaining Standard Confirmations.')
    acquiringStandardConfirmationInstructions.value = false
    return
  } else {
    warningToast('Something went wrong while sending the Standard Confirmation instructions. Please try again later.')
    acquiringStandardConfirmationInstructions.value = false
    return
  }
}

function getOptions() {
  const insts = sortByInArray(institutions.value, 'name')
  let opts = []
  for (let i = 0; i < insts.length; i++) {
    const institution = insts[i]
    if (activeInstitutionId.value === institution.id) {
      activeInstitution.value = {
        id: institution.id,
        name: `${institution.name} - ${institution.id}`,
      }
    }
    opts.push({
      id: institution.id,
      name: `${institution.name} - ${institution.id}`,
    })
  }
  options.value = opts
  return opts
}

function removeNumberFromName(name) {
  const numbers = name.substring(0, 4)
  if (!isNaN(parseInt(numbers)) && !isNaN(numbers)) {
    return name.substring(4, name.length)
  }
  return name
}

async function getUserInfo() {
  try {
    let route = `/users/${clientSession.userId}`
    isLoading.value = true
    let response = await axios.get(route)

    const { id, firstName, lastName, institutionName, institutionLogo } = response.data

    user.id = id
    user.firstName = firstName
    user.lastName = lastName
    user.institution.name = institutionName
    user.institution.logo = institutionLogo
  } catch (error) {
    handleApiErr(error)
  } finally {
    isLoading.value = false
  }
}

function getInstitutionsName() {
  let name = ''
  if (user.institution.institutionName) {
    name = removeNumberFromName(user.institution.institutionName)
  }
  institutions.value.map((institution) => {
    if (parseInt(activeInstitutionId.value) === parseInt(institution.id)) {
      name = institution.name
    }
  })
  return name
}

async function getInstitutionsLogo() {
  try {
    let route = `/institutions/${activeInstitutionId.value}`
    isLoading.value = true
    let response = await axios.get(route)
    if (response.status === 200) {
      return response.data.logo
    }
  } catch (error) {
    handleApiErr(error)
  } finally {
    isLoading.value = false
  }
}

async function getInstitutionsLookup() {
  try {
    let route = `/institutions?perPage=5000`
    isLoading.value = true
    let response = await axios.get(route)
    institutions.value = response.data.records
    getOptions()
  } catch (error) {
    handleApiErr(error)
  } finally {
    isLoading.value = false
  }
}

async function getSiteLookup() {
  try {
    let route = `/sites`
    isLoading.value = true
    let response = await axios.get(route)
    sites.value = []
    response.data.records.map((site) => {
      sites.value.push({
        id: site.id,
        name: site.name,
        url: site.url,
      })
    })
  } catch (error) {
    handleApiErr(error)
  } finally {
    isLoading.value = false
  }
}

async function setActiveInstitutionId(id) {
  if (activeInstitutionId.value !== id) {
    try {
      // the answer is the session (post-login steps re-evaluated): authFlow puts it in appState, and the glue fills Vuex from it
      const session = await authFlow.changeInstitution(id)
      // refused (401, not a member): the session is already cleared, so no reload, as before
      if (!session) return
      router.replace('/').then(() => {
        location.reload()
      })
    } catch (error) {
      handleApiErr(error)
    } finally {
      isLoading.value = false
    }
  }
}

onMounted(async () => {
  bus.emit('full-screen-toggle', true)
  // Set layout attribute
  const appBody = document.getElementById('app-body-area')
  if (appBody) {
    appBody.setAttribute('activeLayout', props.activeLayout)
  } else {
    document.getElementById('app-body-area-cp')?.setAttribute('activeLayout', props.activeLayout)
  }

  await getUserInfo()
  await getInstitutionsLookup()
  // await getInstitutionCarrierAuditStatus()
  await getMembershipData()

  if (props.activeLayout === 'administrative') {
    await getSiteLookup()
  }

  if (!['Staff', 'Manager'].includes(clientSession.userRole)) {
    const l = await getInstitutionsLogo()
    if (l) logo.value = l
  }
  if (!logo.value) {
    logo.value = activeSite.logoUrl
  }

  bus.on('updated-user', (_user) => {
    user.id = _user.id
    user.firstName = _user.firstName
    user.lastName = _user.lastName
    // keep institution as is
  })

  bus.on('full-screen-toggle', (val) => {
    isFullScreen.value = val
  })
})

watch(
  () => activeInstitutionId.value,
  () => {
    getOptions()
  }
)
</script>

<style lang="scss">
.annotationLayer,
.annotationLayer section {
  position: absolute;
  display: none !important;
}

#header-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  z-index: 30;
}

.annotationLayer,
.annotationLayer section {
  position: absolute;
  display: none !important;
}

#app-body-area[activelayout='osr-facing'] {
  width: 80%;
  right: 0 !important;
  background-color: #21335a;
}

#app-body-area[activelayout='administrative'] {
  top: 99px;
  width: 100% !important;
  left: 0 !important;
}

#header-area.client {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
}

#header-area.osr {
  position: relative !important;

  &.osr-header-area {
    background-color: white !important;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .left-side,
    > .center-side,
    > .right-side {
      padding: 10px 20px;
      display: flex;
      align-items: center;
    }

    > .left-side {
      justify-content: flex-start;
      flex: 1;
      min-width: 0;

      > img.bank-logo {
        margin-right: 20px;
        flex-shrink: 0;
        max-height: 50px;
        max-width: 250px;
        width: auto;
        margin-top: -10px;

        // @media (max-width: 1024px) {
        //   display: none;
        // }
      }

      > .bank-name {
        font-size: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
      }
    }

    > .right-side {
      display: grid;
      gap: 4px;
      flex-shrink: 0;

      &.grid-2x2 {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
      }

      &.grid-1x3 {
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr;
      }

      .button {
        flex-shrink: 0;
      }

      @media (max-width: 1024px) {
        display: none;
      }
    }
  }
}

#header-area.client div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: center;
  align-items: center;
}

#header-area.client #header-left {
  justify-content: flex-start;
  padding: 10px 25px;
}

#header-area.client #header-right {
  justify-content: flex-end;
  padding: 10px 20px;
}

#header-left {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 30%;
  height: 70px;
}

#header-right {
  position: absolute;
  right: 10px;
  top: 10px;
  height: 70px;
  width: 30%;
}

#header-right > img {
  max-height: 70px;
}

.header--container {
  background-color: #d9d9d9;
}

#header-center {
  top: 10px;
  height: 70px;
  width: 40%;
  margin: auto;
}

#header-logo {
  height: 70px;
  background-repeat: no-repeat;
  background-position: top 0px left 0px;
}

#institution-selector {
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  border: 1px solid var(--bcc-color-default-hover);
  text-align: center;
}

#institution-selector > option {
  text-align: left !important;
  text-align-last: left !important;
}

#institution-switcher.osr-facing {
  position: relative;
  background-color: var(--bcc-color-default);
  padding: 10px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  z-index: 35;
}

#institution-switcher.admin-facing {
  position: relative;
  padding-top: 10px;

  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  z-index: 35;
}

#institution-switcher.admin-facing input ~ i {
  position: absolute;
  right: 8px !important;
  top: 8px !important;
}

#institution-switcher.admin-facing input {
  background-color: #f5f5f5;
}

#switch-institutions {
  position: absolute;
  left: 20px;
  float: left;
  color: white;
}

@media (max-width: 800px) {
  #institution-switcher.osr-facing {
    display: flex;
    flex-direction: row;
  }

  #institution-selector {
    width: 100%;
  }

  #switch-institutions {
    position: relative;
    width: 100%;
  }

  #header-right {
    display: none !important;
  }

  #header-right > img {
    display: inherit;
  }

  #header-center {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start !important;
    align-content: center;
  }

  #header-left {
    padding: 0 !important;
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto 0 !important;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start !important;
    left: 0px !important;
  }

  #header-area.client {
    flex-direction: column;
    height: auto;
    justify-content: flex-start;
    align-items: center;

    padding: 20px;
    padding-bottom: 30px;
  }

  #header-area {
    padding: 0px;
    margin: 0px;
    position: inherit;
  }
}

#header-right {
  height: 100%;
}

#header-right > div.flex {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
}

#header-left {
  height: 100%;
}

#header-left.flex {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
</style>
